import React, { useEffect, useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./AddAssistantPopup.css";
import api from "./../../../axiosInstance"
import logger from "../../../utils/logger";

const AddAssistantPopup = ({ open, setAddAssistantPopup, onSubmit }) => {
  const [searchAssistantsData, setSearchAssistantsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const popupRef = useRef(null);

  const fetchSearchAssistantsAPI = async (searchQuery) => {
    if (!open) return [];
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/search/assistants/?searchQuery=${searchQuery}`;
    try {
      const response = await api.get(`/search/assistants`,{
        params : {
          searchQuery:searchQuery
        }
      })

      const data = response.data
      setSearchAssistantsData(data);
      logger.debug("API Response Data:", data);
    } catch (error) {
      logger.error("Error fetching search assistants data:", error);
    }
  };

  useEffect(() => {
    if (open) {
      fetchSearchAssistantsAPI(searchQuery);
    }
  }, [open, searchQuery]);

  const handleSearchChange = (event) => {
    const searchQuery = event.target.value;
    setSearchQuery(searchQuery);
  };

  const handleSelectAssistant = (assistant) => {
    setSelectedAssistant(assistant);
    setSearchQuery(
      `${assistant.name.firstName} ${(assistant.name.middleName || "")} ${assistant.name.lastName}`
    );
    setSearchAssistantsData([]);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (selectedAssistant) {
      onSubmit(selectedAssistant);
      setAddAssistantPopup(false);
    } else {
      alert("Please select an assistant from the search results.");
    }
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setAddAssistantPopup(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="overlay_page">
      <div className="appointmentCalendar" ref={popupRef}>
        <div className="cross-icon_container" onClick={() => setAddAssistantPopup(false)}>
          <CloseIcon className="cross_icon-image" />
        </div>
        <div className="appointmentCalendar-content">
          <h2>Search Assistant</h2>
          <div className="appointmentCalendar-content-section">
            <p>Enter Assistant's Name or Specialization</p>
            <input
              type="text"
              placeholder="Search Assistant Name/Specialization"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div>
            {searchAssistantsData.length > 0 ? (
              searchAssistantsData.map((assistant, index) => (
                <div
                  className="search-card-appointment_calendar"
                  key={index}
                  onClick={() => handleSelectAssistant(assistant)}
                >
                  <div className="search-section-appointment_calendar">
                    <img src={assistant.img} alt={assistant.name.firstName} />
                    <p>{assistant.name.firstName} {assistant.name.lastName}</p>
                    <p>{assistant.specialization}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>No results found</p>
            )}
          </div>
          <button className="search-button" onClick={handleFormSubmit}>
            Add
          </button>
          <button className="search-button" onClick={() => setAddAssistantPopup(false)}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAssistantPopup;
